/* eslint-disable react/no-unstable-nested-components */
import { useContext } from 'react';
import { InputLabel, MenuItem, Select, useMediaQuery, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CustomSelectStyles as classes } from './CustomSelectStyles';
import { CommonStyles } from '../CommonStyles';
import { commonTernary } from '../../commonCode';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { DownArrowIcon } from '../../../images/svg/CustomizedSVG';

export const CustomSelectAccount = ({
  id,
  dataTestId,
  required,
  inputLabelAriaLabel,
  inputLabelClassName,
  label,
  autoFocus,
  options,
  InputClassName,
  handleChange,
  fullWidth,
  value,
  selectAriaLabel,
  disabled,
  nsSeparator,
  isState,
  dataTestIdForLabel,
  isUtilityBill,
  error,
  showLabel,
  textLabel,
  flow,
  isBundle,
  // noPlaceHolderLabel,
  // corporateTitlePlaceholder,
}) => {
  const themes = useTheme();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { theme } = leadGenerationContext;

  const styles = CommonStyles(theme);
  const isMobile = useMediaQuery(themes?.breakpoints?.between('960', '1209'), {
    defaultMatches: true,
  });
  const { t } = useTranslation();
  const commonSelectFunction = (data1, data2) => {
    let data;
    if (data1) {
      data = data1;
    } else {
      data = data2;
    }
    return data;
  };

  const labelStyle = [{ fontSize: '16px', marginBottom: '10px' }];

  return (
    <>
      <InputLabel
        data-testid={commonSelectFunction(dataTestIdForLabel, null)}
        htmlFor={commonSelectFunction(id, null)}
        aria-label={commonSelectFunction(inputLabelAriaLabel, null)}
        sx={[
          classes.label_title,
          commonSelectFunction(inputLabelClassName, ''),
          isBundle ? styles.label_title : labelStyle,
        ]}
        required={commonSelectFunction(required, false)}
        // style={{ fontSize: '16px', marginBottom: '10px' }}
      >
        {commonSelectFunction(label, '')}
      </InputLabel>
      <Select
        variant="outlined"
        role="listbox"
        style={{
          width: '100%',
          ...(isBundle && styles.customBorderRadius),
        }}
        id={commonSelectFunction(id, null)}
        MenuProps={{
          disableScrollLock: true,
          PaperProps: {
            sx: {
              ...theme?.menuBackground,
              border: `1px solid ${theme?.menuBackground?.borderColor} !important`,
              color: `${theme?.palette?.primary?.main} !important`,
            },
            className: isBundle ? 'bundle-menu-paper' : '',
          },
        }}
        sx={commonTernary(
          error,
          [
            classes.select_inputs_ACC,
            commonSelectFunction(InputClassName, ''),
            classes.select_inputs_err,
            ...(isBundle ? [styles.customBorderRadius, styles.outlined_input_bundle] : []),
          ],
          commonTernary(
            disabled,
            [
              classes.select_inputs_ACC,
              commonSelectFunction(InputClassName, ''),
              classes.select_inputs_disabled,
              ...(isBundle ? [styles.customBorderRadius, styles.outlined_input_bundle] : []),
            ],
            [
              classes.select_inputs_ACC,
              commonSelectFunction(InputClassName, ''),
              ...(isBundle ? [styles.customBorderRadius, styles.outlined_input_bundle] : []),
            ]
          )
        )}
        onChange={handleChange}
        disabled={!!disabled}
        name={commonSelectFunction(id, null)}
        inputProps={{ 'data-testid': commonSelectFunction(id, null) }}
        autoFocus={commonSelectFunction(autoFocus, false)}
        aria-label={commonSelectFunction(selectAriaLabel, null)}
        data-testid={commonSelectFunction(dataTestId, '')}
        fullWidth={commonSelectFunction(fullWidth, false)}
        IconComponent={() => (
          <Box padding="0 10px 0 0">
            <DownArrowIcon
              style={{ width: 24, height: 24 }}
              color={theme?.palette?.orientalPrimary?.main}
            />
          </Box>
        )}
        value={commonSelectFunction(value, '')}
        slotProps={{
          icon: {
            sx: classes.select_icon,
          },
          select: {
            sx: commonTernary(
              value === null || value === '' || value === 'Select',
              classes.select_inputs_placeholder,
              commonTernary(disabled, classes.disable_select_style, classes.select_style)
            ),
          },
          notchedOutline: {
            sx: isBundle && { border: 'none !important' },
          },
        }}
        displayEmpty
      >
        <MenuItem role="option" value="">
          {showLabel
            ? t(textLabel, { defaultValue: textLabel })
            : t('Select', { defaultValue: 'Select' })}
        </MenuItem>

        {commonTernary(
          nsSeparator,
          options &&
            Object.keys(options).length > 0 &&
            options.map((option, index) => (
              <MenuItem
                disabled={
                  option.isValids ||
                  option.isDepositeGreaterThanBalancePlaid ||
                  option.isDepositeGreaterThanBalanceAnother ||
                  option.isDepositeGreaterDisableAll
                }
                key={option.Id}
                role="option"
                value={option.Id}
                index={index}
                style={
                  option.isValids ||
                  option.isDepositeGreaterThanBalancePlaid ||
                  option.isDepositeGreaterThanBalanceAnother ||
                  option.isDepositeGreaterDisableAll
                    ? {
                        font: 'normal 700 16px/normal Arial',

                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        color: '#808285',
                      }
                    : {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        font: 'normal 700 16px/normal Arial',
                        color: theme?.palette?.primary?.main,
                      }
                }
              >
                <span
                  style={
                    option.isValids ||
                    option.isDepositeGreaterThanBalancePlaid ||
                    option.isDepositeGreaterThanBalanceAnother ||
                    option.isDepositeGreaterDisableAll
                      ? {
                          font: 'normal 700 16px/normal Arial',

                          color: '#808285',
                        }
                      : {
                          font: 'normal 700 16px/normal Arial',
                          color: theme?.palette?.primary?.main,
                        }
                  }
                >
                  {isMobile
                    ? t(`****${option.AccountNumber.slice(-4)}`, {
                        defaultValue: `****${option.AccountNumber.slice(-4)}`,
                        nsSeparator,
                      })
                    : t(option.AccountNumber, { defaultValue: option.AccountNumber, nsSeparator })}
                </span>
                <span
                  style={
                    option.isValids ||
                    option.isDepositeGreaterThanBalancePlaid ||
                    option.isDepositeGreaterThanBalanceAnother ||
                    option.isDepositeGreaterDisableAll
                      ? {
                          font: 'normal 700 16px/normal Arial',

                          color: '#808285',
                        }
                      : {
                          font: 'normal 700 16px/normal Arial',
                          color: theme?.palette?.primary?.main,
                        }
                  }
                >
                  {t(`$${option.Balance}`, { defaultValue: `$${option.Balance}`, nsSeparator })}
                </span>
              </MenuItem>
            )),
          options &&
            Object.keys(options).length > 0 &&
            options.map((option, index) => (
              <MenuItem
                key={option.Id}
                disabled={
                  option.isValids ||
                  option.isDepositeGreaterThanBalancePlaid ||
                  option.isDepositeGreaterThanBalanceAnother ||
                  option.isDepositeGreaterDisableAll
                }
                role="option"
                value={option.Id}
                index={index}
                style={
                  option.isValids ||
                  option.isDepositeGreaterThanBalancePlaid ||
                  option.isDepositeGreaterThanBalanceAnother ||
                  option.isDepositeGreaterDisableAll
                    ? {
                        font: 'normal 700 16px/normal Arial',

                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        color: '#808285',
                      }
                    : {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        font: 'normal 700 16px/normal Arial',
                        color: theme?.palette?.primary?.main,
                      }
                }
              >
                <span
                  style={
                    option.isValids ||
                    option.isDepositeGreaterThanBalancePlaid ||
                    option.isDepositeGreaterThanBalanceAnother ||
                    option.isDepositeGreaterDisableAll
                      ? {
                          font: 'normal 700 16px/normal Arial',

                          color: '#808285',
                        }
                      : {
                          font: 'normal 700 16px/normal Arial',

                          color: theme?.palette?.primary?.main,
                        }
                  }
                >
                  {isMobile
                    ? t(`****${option.AccountNumber.slice(-4)}`, {
                        defaultValue: `****${option.AccountNumber.slice(-4)}`,
                      })
                    : t(option.AccountNumber, { defaultValue: option.AccountNumber })}
                </span>
                <span
                  style={
                    option.isValids ||
                    option.isDepositeGreaterThanBalancePlaid ||
                    option.isDepositeGreaterThanBalanceAnother ||
                    option.isDepositeGreaterDisableAll
                      ? {
                          font: 'normal 700 16px/normal Arial',

                          color: '#808285',
                        }
                      : {
                          font: 'normal 700 16px/normal Arial',
                          color: theme?.palette?.primary?.main,
                        }
                  }
                >
                  {t(`$${option.Balance}`, { defaultValue: `$${option.Balance}` })}
                </span>
              </MenuItem>
            ))
        )}
      </Select>
    </>
  );
};

CustomSelectAccount.propTypes = {
  id: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  inputLabelAriaLabel: PropTypes.string,
  inputLabelClassName: PropTypes.string,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  showLabel: PropTypes.bool,
  textLabel: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  InputClassName: PropTypes.string,
  handleChange: PropTypes.func,
  fullWidth: PropTypes.bool,
  isState: PropTypes.bool,
  isUtilityBill: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectAriaLabel: PropTypes.string,
  dataTestId: PropTypes.string,
  nsSeparator: PropTypes.string,
  dataTestIdForLabel: PropTypes.string,
  flow: PropTypes.string,
  isBundle: PropTypes.bool,
  // noPlaceHolderLabel: PropTypes.bool,
  // corporateTitlePlaceholder: PropTypes.bool,
};
